import { IApplicationState } from '@Site/rootReducer'
import { createSelector } from 'reselect'
import reduce from 'lodash/reduce'

import {
  ICreditUsageEntry,
  IProjectCreationEntry,
} from '@SiteModules/Statistics/types'

export const getCreditUsageDataNonAnalysis = (state: IApplicationState): ICreditUsageEntry[] => state.statistics.creditUsageData.nonAnalysis
export const getCreditUsageDataAnalysis = (state: IApplicationState): ICreditUsageEntry[] => state.statistics.creditUsageData.analysis
export const getProjectCreationData = (state: IApplicationState): IProjectCreationEntry[] => state.statistics.projectCreationData

export const getCreditUsageSumNonAnalysis = createSelector(
  [getCreditUsageDataNonAnalysis],
  (creditUsageData) => reduce(creditUsageData, (sum, entry) => sum + entry.credits, 0)
)

export const getCreditUsageSumAnalysis = createSelector(
  [getCreditUsageDataAnalysis],
  (creditUsageData) => reduce(creditUsageData, (sum, entry) => sum + entry.credits, 0)
)

export const getProjectCreationSum = createSelector(
  [getProjectCreationData],
  (projectCreationData) => reduce(projectCreationData, (sum, entry) => sum + entry.projectsCount, 0)
)
